import * as React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import { ShippingLine } from 'types/Shipping';
import { ShippingLineAutoComplete } from 'components/Selectors/ShippingLineAutocomplete';

export const ShippingLineFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);
  const handleOnChange = (events: React.SyntheticEvent, values: ShippingLine[]) => {
    setSearchParams({
      shippingLine: values.map((ssl) => ssl.key),
    });
  };

  const defaultValue = searchParams.shippingLine;

  return (
    <ShippingLineAutoComplete
      defaultValue={defaultValue}
      onChange={handleOnChange}
      className="px-2"
    />
  );
};
ShippingLineFilter.displayName = 'TrackAndTrace.Controls.filters.ShippingLineFilter';
